exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "@keyframes fadeIn {\n  from {\n    opacity: 0; }\n  to {\n    opacity: 1; } }\n\n.node-editor {\n  padding: 1.5rem 1rem;\n  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.2); }\n  @media (max-width: 768px) {\n    .node-editor {\n      box-shadow: none; } }\n  .node-editor > *:not(label) {\n    display: block;\n    margin: 20px 0; }\n  .node-editor input.node-id {\n    cursor: not-allowed;\n    background-color: #ccc;\n    color: #666; }\n  .node-editor input,\n  .node-editor textarea,\n  .node-editor select {\n    width: 100%;\n    border: solid 1px #aaa;\n    font-size: 1rem;\n    padding: 5px 10px;\n    border-top-right-radius: 0.3rem;\n    border-bottom-right-radius: 0.3rem;\n    border-left-color: transparent;\n    align-self: center; }\n    @media (max-width: 768px) {\n      .node-editor input,\n      .node-editor textarea,\n      .node-editor select {\n        border-left-color: #aaa; } }\n  .node-editor textarea {\n    min-height: 450px;\n    padding: 20px; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js!./src/StoryEditor/NodeEditor/NodeEditor.scss
// module id = 163
// module chunks = 0